import React, { useEffect, useState } from "react";
import Logo1 from "Assets/monitoring/polrilogo3.png";
import LogoPoldaBali from "Assets/logo/poldaBali.png";
// import LogoPoldaBali from "../../../assets/logo/poldaBali.png";
import logo_live_on from "Assets/monitoring/fluent_location-live-24-regular-1.svg";
import logo_live_off from "Assets/monitoring/fluent_location-live-24-regular.svg";
import logo_playback_off from "Assets/monitoring/mage_video-player-1.svg";
import logo_playback_on from "Assets/monitoring/mage_video-player.svg";
import { NavLink, useLocation } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { playbackSidebar } from "slice/playbackSlice";

const NavbarMonitoring = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathUrl = location.pathname;
  const isRealTime =
  pathUrl === "/monitoring" || pathUrl.startsWith("/monitoring/live");
  const [navigation, setNavigation] = useState([
    {
      name: "Live",
      href: "/monitoring/live",
      icon: logo_live_on,
      current: true,
    },
    {
      name: "Playback",
      href: "/monitoring/playback",
      icon: logo_playback_off,
      current: false,
    },
  ]);
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(true);
  // console.log(navigation, '')

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      setTime(formattedTime);
      setLoading(false);
    };

    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // console.log("pathUrl:", pathUrl);
    if (isRealTime) {
      const arrayNav = navigation;
      arrayNav[0].current = true;
      arrayNav[1].current = false;
      arrayNav[0].icon = logo_live_on;
      arrayNav[1].icon = logo_playback_off;
      setNavigation(arrayNav);
      dispatch(playbackSidebar(""));
      // dispatch(playbackSidebar(0));
    } else {
      const arrayNav = navigation;
      arrayNav[0].current = false;
      arrayNav[1].current = true;
      arrayNav[0].icon = logo_live_off;
      arrayNav[1].icon = logo_playback_on;
      setNavigation(arrayNav);
    }
  }, [pathUrl]);

  return (
    <nav className="flex flex-wrap md:flex-nowrap justify-between items-center px-4 sm:px-6 lg:px-8 text-white gap-4 ">
      {/* Left Section */}
      <div className="w-full md:w-1/3 flex flex-wrap gap-2 justify-center md:justify-start">
        <div className="flex flex-wrap gap-2 justify-center md:justify-start w-full">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={`flex items-center px-4 py-2 gap-2 rounded-md text-sm font-medium whitespace-nowrap ${
                item.current === false
                  ? "bg-cyan-900 text-cyan-700"
                  : "bg-mo-button text-mo-text"
              }`}
            >
              <img src={item.icon} alt="logo" className="h-5 w-auto" />
              {item.name}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Center Section */}
      <div className="w-full md:w-1/3 flex justify-center items-center text-center gap-4">
        <img
          src={Logo1}
          alt="Logo 1"
          className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] object-contain"
        />
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-300">
          SISTEM PENGAWASAN
        </h1>
        <img
          src={LogoPoldaBali}
          alt="Logo 2"
          className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] object-contain"
        />
      </div>

      {/* Right Section */}
      <div className="w-full md:w-1/3 flex flex-col items-center md:items-end justify-center md:justify-end gap-1">
        {loading ? (
          <div className="flex justify-center md:justify-end">
            <CircularProgress />
          </div>
        ) : (
          <>
            <span className="text-xl sm:text-2xl font-mono text-blue-300">
              {time}
            </span>
            <span className="text-sm sm:text-base text-blue-300 text-center md:text-right whitespace-nowrap">
              {new Date().toLocaleDateString("id-ID", {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </>
        )}
      </div>
    </nav>
  );
};

export default NavbarMonitoring;
